var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcerts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "2113qr0mfa",
    d: "M0 0L24.029 0 24.029 22.5 0 22.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M0 21.087L23.292 21.087 23.292 13.74 0 13.74z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "x9f6tn78nb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2113qr0mfa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M24.03 12.403c0-2.932-2.273-1.058-5.49-5.539C15.15 2.146 13.102-.019 8.38 0 3.728.02 0 3.867 0 8.517v13.276c0 .39.316.707.707.707h22.616c.39 0 .706-.317.706-.707v-9.39zm-1.415 8.684H1.413v-5.654h1.414v3.179c0 .196.157.354.357.354h.7c.197 0 .356-.16.356-.354v-3.179h.708v3.179c0 .196.156.354.356.354h.7c.197 0 .357-.16.357-.354v-3.179h2.826v3.179c0 .196.157.354.358.354h.7c.196 0 .356-.16.356-.354v-3.179h.707v3.179c0 .196.156.354.356.354h.7c.198 0 .358-.16.358-.354v-3.179h.706v3.179c0 .196.157.354.357.354h.7c.197 0 .356-.16.356-.354v-3.179h2.828v3.179c0 .196.157.354.356.354h.7c.198 0 .357-.16.357-.354v-3.179h.707v3.179c0 .196.156.354.357.354h.7c.196 0 .356-.16.356-.354v-3.179h1.413v5.654z",
    mask: "url(#x9f6tn78nb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcerts);
export default __webpack_public_path__ + "static/media/concerts.2c95b6b7f5f4d272842c549219b468ed.svg";
export { ForwardRef as ReactComponent };